var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.418,
    height: 117.563,
    viewBox: "0 0 137.418 117.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1806",
    "data-name": "Ret\\xE2ngulo 1806",
    width: 137.418,
    height: 117.563,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4127",
    "data-name": "Grupo 4127",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1915",
    "data-name": "Caminho 1915",
    d: "M137.418,78.831v83.048a5.376,5.376,0,0,1-5.983,3.854c-1.245-.09-2.5-.015-3.755-.015h-2.343a2.328,2.328,0,0,1-.172-.372c-.015-1.383-.018-2.766-.043-4.149-.032-1.707-.961-2.777-2.4-2.791-1.488-.015-2.459,1.1-2.476,2.869-.014,1.457,0,2.915,0,4.331H17.178v-1.7q0-29.121,0-58.243a10.48,10.48,0,0,0-.037-1.47,2.389,2.389,0,0,0-2.533-2.087,2.323,2.323,0,0,0-2.285,2.186c-.051.531-.029,1.07-.029,1.606q0,28.987,0,57.975v1.848c-2.166,0-4.174-.1-6.168.024-3.029.19-5.087-.987-6.124-3.862V78.831c1.173-2.855,3.342-3.773,6.363-3.767q43.73.094,87.46.037h1.649c.108.2.187.275.188.352.021,3.971.043,7.942.034,11.912a1.209,1.209,0,0,1-.39.774C92.812,90.438,90.3,92.711,87.8,95a5.83,5.83,0,0,0-1.92,4.534c.018,7.007,0,14.014.011,21.021a5.611,5.611,0,0,0,5.942,5.977q6.3.025,12.609,0c3.575-.013,5.935-2.263,5.957-5.809.044-7.1.006-14.192.018-21.289a5.868,5.868,0,0,0-1.985-4.506,49.1,49.1,0,0,0-4.988-4.658c-2.5-1.743-3.107-3.925-2.866-6.784.23-2.734.049-5.5.049-8.387h1.59c9.568,0,19.138.071,28.705-.041,3.058-.036,5.3.853,6.5,3.771m-12.291,40.461v-4.282q0-13.516.008-27.033c0-1.08-.094-2.188-1.172-2.628a3.628,3.628,0,0,0-2.393-.073c-1.141.408-1.338,1.518-1.338,2.668q.019,31.249.011,62.5c0,1.9.921,3.043,2.433,3.057s2.429-1.118,2.45-3.025c0-.357,0-.714,0-1.07V119.292M12.3,90.949c0,1.249-.035,2.5.009,3.747a2.322,2.322,0,0,0,2.325,2.426,2.359,2.359,0,0,0,2.521-2.382c.057-2.452.054-4.907,0-7.36a2.358,2.358,0,0,0-2.479-2.425,2.343,2.343,0,0,0-2.374,2.514c-.036,1.159-.007,2.32,0,3.479",
    transform: "translate(0 -48.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1916",
    "data-name": "Caminho 1916",
    d: "M268.355,141.162c0,3.346-.033,6.692.018,10.037.017,1.091-.336,1.514-1.458,1.5q-5.9-.066-11.8,0c-1.1.011-1.51-.378-1.505-1.481.029-6.781,0-13.562.047-20.343a2.546,2.546,0,0,1,.724-1.595c1.83-1.831,3.758-3.564,5.6-5.382a1.235,1.235,0,0,1,2.038-.021c1.887,1.838,3.842,3.607,5.7,5.477a2.576,2.576,0,0,1,.61,1.636c.055,3.39.027,6.781.027,10.171",
    transform: "translate(-162.854 -79.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1917",
    "data-name": "Caminho 1917",
    d: "M165.533,12.2c-3.888,0-7.777.007-11.665,0-2.234-.005-3.055-.836-3.065-3.085-.009-2.1-.02-4.194,0-6.291.022-1.892.911-2.8,2.8-2.8q11.933-.024,23.867,0c1.892,0,2.772.91,2.794,2.814q.037,3.278,0,6.558c-.022,1.891-.923,2.8-2.8,2.8-3.978.019-7.956.006-11.934.006",
    transform: "translate(-96.829 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1918",
    "data-name": "Caminho 1918",
    d: "M261.432,27.089h-7.16c-.026-.6-.072-1.155-.073-1.713-.011-4.794-2.16-8.148-6.657-9.967a1.274,1.274,0,0,1-.7-.881c-.061-2.178-.032-4.359-.032-6.526,7.632-.963,15.694,9.549,14.625,19.086",
    transform: "translate(-158.48 -5.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1919",
    "data-name": "Caminho 1919",
    d: "M110.66,7.881c0,2.261.019,4.528-.028,6.793,0,.235-.359.573-.624.677-4.7,1.843-6.818,5.351-6.738,10.3.007.434-.037.869-.06,1.371H96.092c-1.606-8.808,6.379-19.361,14.568-19.144",
    transform: "translate(-61.571 -5.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1920",
    "data-name": "Caminho 1920",
    d: "M27.584,52.706a23.553,23.553,0,0,1,.023-2.815,2.052,2.052,0,0,1,2.049-1.93c1.821-.081,3.653-.092,5.473-.006a2.162,2.162,0,0,1,2.144,2.151c.083.829.016,1.674.016,2.6Z",
    transform: "translate(-17.691 -30.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1921",
    "data-name": "Caminho 1921",
    d: "M338.934,52.727h-9.726a20.9,20.9,0,0,1,.024-2.784,2.14,2.14,0,0,1,2.15-2c1.778-.069,3.563-.074,5.341,0a2.2,2.2,0,0,1,2.2,2.238c.062.791.012,1.591.012,2.545",
    transform: "translate(-211.374 -30.753)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIcon);
export default __webpack_public_path__ + "static/media/suitcaseIcon.2d3da4c2124474c5411fc61c1f5bd8ce.svg";
export { ForwardRef as ReactComponent };